module.exports = __webpack_public_path__ + "static/img/logo_bodytone_top_main2.2058d11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_bodytone_top_main2.png
// module id = Fzy4
// module chunks = 1